export const MAX_PERIOD_YEARS = 1;

export const PRODUCTS = Object.freeze({
    ALL: 'All',
    CASINO: 'Casino',
    SPORTSBOOK: 'Sportsbook'
});

export const REPORT_TYPES = Object.freeze({
    TRANSACTION: 'Transaction',
    WIN_LOSS: 'Win/Loss(Period)'
});
